const Haiku = require('@haiku/core');

module.exports = {
  options: {
    mixpanel: false,
  },
  states: {},
  eventHandlers: {},
  timelines: {
    Default: {
      'haiku:1-0a54a29a9621f927': {
        fill: '#F2A000',
        points: '0 3.29705882 40 3.29705882 40 0 0 0',
      },
      'haiku:Main-03757d2ca1026e0a': {
        'style.WebkitTapHighlightColor': 'rgba(0,0,0,0)',
        'style.position': 'relative',
        'style.overflowX': '',
        'style.overflowY': '',
        'sizeAbsolute.x': 100.692,
        'sizeAbsolute.y': 87.782,
        'sizeMode.x': 1,
        'sizeMode.y': 1,
        'sizeMode.z': 1,
        'style.display': 'flex',
        'style.justifyContent': 'center',
        'style.justifyItems': 'center',
        'style.marginLeft': '-45%',
        'style.marginTop': '-60%',
      },
      'haiku:Page-1-ea05a848d79a87bb': {
        stroke: 'none',
        strokeWidth: 1,
        fill: 'none',
        fillRule: 'evenodd',
      },
      'haiku:Circle-13f78542ad8c7575': {
        d:
          'M52.124486,42.5118332 C47.8248811,49.3907617 40.2280094,53.3320143 31.2727566,53.3320143 L31.2127711,53.3320143 C17.8185923,53.3046191 6.92251875,42.8140933 6.92251875,29.9465794 C6.92251875,17.3420592 18.2365557,6.69172818 31.6268645,6.69172818 C39.9145368,6.69172818 47.5007659,10.8996271 51.9222769,17.9465794 L51.9919374,18.0588996 L59.8219786,18.0588996 L59.69717,17.7493341 C55.4914134,7.29807473 43.9432395,0 31.6142869,0 C14.1817302,0 0,13.4802526 0,30.0479416 C0,46.5635796 14.2688059,60 31.8068209,60 C44.0632105,60 54.8073853,53.3776729 59.8471338,42.7209497 L60,42.3985998 L52.1941466,42.3985998 L52.124486,42.5118332 Z',
        fill: '#001A70',
      },
      'haiku:1-8a11af0c9f349080': {
        'translation.y': 37.367,
        'style.position': 'absolute',
        'style.padding': '0',
        'style.border': '0',
        'sizeAbsolute.x': 40,
        'sizeMode.x': 1,
        'sizeAbsolute.y': 4,
        'sizeMode.y': 1,
        'translation.x': 40.1,
        'style.margin': '0',
        'style.zIndex': 2,
        'origin.x': -0.01,
        'origin.y': 0.5,
        opacity: 1,
        'rotation.x': 0,
        'rotation.z': 0,
        'scale.x': {
          0: {
            value: 0,
            edited: true,
          },
          333: {
            value: 0,
            edited: true,
            curve: 'easeInOutQuad',
          },
          533: {
            value: 1,
            edited: true,
          },
        },
        'scale.y': 1,
        'scale.z': 1,
      },
      'haiku:Page-1-b9f5154de0185ca2': {
        stroke: 'none',
        strokeWidth: 1,
        fill: 'none',
        fillRule: 'evenodd',
      },
      'haiku:Circle-0005699d21d02ca4': {
        'sizeAbsolute.y': 60,
        'style.position': 'absolute',
        'style.padding': '0',
        'style.border': '0',
        'sizeAbsolute.x': 60,
        'sizeMode.x': 1,
        'style.margin': '0',
        'sizeMode.y': 1,
        'translation.x': 42,
        'translation.y': 43,
        'style.zIndex': 1,
        'rotation.z': {
          0: {
            value: 3.06,
            edited: true,
            curve: 'easeInOutQuad',
          },
          333: {
            value: 0,
            edited: true,
          },
        },
        opacity: 1,
      },
      'haiku:2-96767abfd047dd1f': {
        'sizeMode.y': 1,
        'style.position': 'absolute',
        'style.padding': '0',
        'style.border': '0',
        'sizeAbsolute.x': 50,
        'sizeMode.x': 1,
        'sizeAbsolute.y': 4,
        'style.margin': '0',
        'translation.x': 38.962,
        'translation.y': 43.698,
        'style.zIndex': 3,
        'origin.x': -0.038,
        'origin.y': 0.602,
        opacity: 1,
        'scale.x': {
          0: {
            value: 0,
            edited: true,
          },
          533: {
            value: 0,
            edited: true,
            curve: 'easeInOutQuad',
          },
          733: {
            value: 1,
            edited: true,
          },
        },
      },
      'haiku:Page-1-046555d7168ba223': {
        stroke: 'none',
        strokeWidth: 1,
        fill: 'none',
        fillRule: 'evenodd',
      },
      'haiku:2-6e522988aa8d6194': {
        fill: '#F2A000',
        points: '0 3.70098039 50 3.70098039 50 0.402941176 0 0.402941176',
      },
      'haiku:3-cf7ba02de7a59126': {
        'sizeMode.y': 1,
        'style.position': 'absolute',
        'style.padding': '0',
        'style.border': '0',
        'sizeAbsolute.x': 35,
        'sizeMode.x': 1,
        'sizeAbsolute.y': 5,
        'style.margin': '0',
        'translation.x': 41.706,
        'translation.y': 49.09,
        'style.zIndex': 4,
        'origin.x': 0.02,
        'origin.y': 0.418,
        'scale.x': {
          0: {
            value: 0,
            edited: true,
          },
          733: {
            value: 0,
            edited: true,
            curve: 'easeInOutQuad',
          },
          933: {
            value: 1,
            edited: true,
          },
        },
      },
      'haiku:Page-1-c84505a52732e19a': {
        stroke: 'none',
        strokeWidth: 1,
        fill: 'none',
        fillRule: 'evenodd',
      },
      'haiku:3-2e4ae4afc62d4dd3': {
        fill: '#F2A000',
        points: '0 4.10392157 35 4.10392157 35 0.806862745 0 0.806862745',
      },
    },
  },
  template: {
    elementName: 'div',
    attributes: {
      class:
        'Main-03757d2ca1026e0a d-flex justify-content-center align-items-center',
      'haiku-id': 'Main-03757d2ca1026e0a',
      'haiku-title': 'Main',
    },
    children: [
      {
        elementName: 'svg',
        attributes: {
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          'xmlns:xlink': 'http://www.w3.org/1999/xlink',
          'haiku-id': '3-cf7ba02de7a59126',
          'haiku-title': '3',
          'haiku-source': 'designs/logb.sketch.contents/slices/3.svg',
        },
        children: [
          {
            elementName: 'g',
            attributes: {
              'haiku-id': 'Page-1-c84505a52732e19a',
              id: 'Page-1',
            },
            children: [
              {
                elementName: 'polygon',
                attributes: {
                  'haiku-id': '3-2e4ae4afc62d4dd3',
                  id: '3',
                },
                children: [],
              },
            ],
          },
        ],
      },
      {
        elementName: 'svg',
        attributes: {
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          'xmlns:xlink': 'http://www.w3.org/1999/xlink',
          'haiku-id': '2-96767abfd047dd1f',
          'haiku-title': '2',
          'haiku-source': 'designs/logb.sketch.contents/slices/2.svg',
        },
        children: [
          {
            elementName: 'g',
            attributes: {
              'haiku-id': 'Page-1-046555d7168ba223',
              id: 'Page-1',
            },
            children: [
              {
                elementName: 'polygon',
                attributes: {
                  'haiku-id': '2-6e522988aa8d6194',
                  id: '2',
                },
                children: [],
              },
            ],
          },
        ],
      },
      {
        elementName: 'svg',
        attributes: {
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          'xmlns:xlink': 'http://www.w3.org/1999/xlink',
          'haiku-id': '1-8a11af0c9f349080',
          'haiku-title': '1',
          'haiku-source': 'designs/logb.sketch.contents/slices/1.svg',
        },
        children: [
          {
            elementName: 'g',
            attributes: {
              'haiku-id': 'Page-1-b9f5154de0185ca2',
              id: 'Page-1',
            },
            children: [
              {
                elementName: 'polygon',
                attributes: {
                  'haiku-id': '1-0a54a29a9621f927',
                  id: '1',
                },
                children: [],
              },
            ],
          },
        ],
      },
      {
        elementName: 'svg',
        attributes: {
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          'xmlns:xlink': 'http://www.w3.org/1999/xlink',
          'haiku-id': 'Circle-0005699d21d02ca4',
          'haiku-title': 'CIRCLE',
          'haiku-source': 'designs/logb.sketch.contents/slices/CIRCLE.svg',
        },
        children: [
          {
            elementName: 'g',
            attributes: {
              'haiku-id': 'Page-1-ea05a848d79a87bb',
              id: 'Page-1',
            },
            children: [
              {
                elementName: 'path',
                attributes: {
                  'haiku-id': 'Circle-13f78542ad8c7575',
                  id: 'CIRCLE',
                },
                children: [],
              },
            ],
          },
        ],
      },
    ],
  },
  mixpanel: false,
};
